<template>
    <v-container id="general-report" fluid tag="section">
<!--        <filter-form :filterForm="filterForm" />-->
        <partner-report-table
            :filterForm="filterForm"
            :dataRevenue="dataRevenue"
            :dataEarning="dataEarning"
            :dataTransaction="dataTransaction" />
    </v-container>
</template>

<script>
import moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory"
import PartnerReportTable from "@/pages/report/partner-report/components/PartnerReportTable";

const ReportRepository = RepositoryFactory.get('report')

export default {
    components: { PartnerReportTable },
    data() {
        return {
            filterForm: {
                dateRange: {
                    startDate: moment().startOf('month').format('YYYY-MM-DD'),
                    endDate: moment().endOf('month').format('YYYY-MM-DD'),
                }
            },
            dataRevenue: {
              totalSuccessOrderByDate: 0,
              totalSuccessRevenue: 0,
              totalSuccessOrderByAcc: 0,
              totalRevenueByDateByAcc: 0,
              roseByDate: 0,
              roseByAcc: 0,
            },
            dataEarning: {
              roseCurrent: 0,
              bonusCurrent: 0
            },
            dataTransaction: {

            },
            filterFormTransaction: {
              month: moment().format('YYYY-MM')
            }
        }
    },
    created() {
        this.getRevenueReport();
        this.getEarningReport();
        this.getTransactionReport();
        Bus.$on('revenue-report-list-filter', filterForm => {
            this.filterForm = filterForm
            this.getRevenueReport()
        })

        Bus.$on('transaction-report-list-filter', filterForm => {
          this.filterFormTransaction = filterForm
          this.getTransactionReport()
        })
        Bus.$on("policy-ctv-updated", data => {
          this.getRevenueReport();
          this.getEarningReport();
          this.getTransactionReport();
        })
    },
    methods: {
        async getRevenueReport() {
            const loading = this.$loading.show()
            const params = {
                startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
            }
            
            const res = await ReportRepository.revenuePartnerReport(params)
            if (res.success) {
                this.dataRevenue = _.get(res, 'data', {})
            }
            loading.hide()
        },
        async getEarningReport() {
          const loading = this.$loading.show()

          const res = await ReportRepository.earningPartnerReport()
          if (res.success) {
            this.dataEarning = _.get(res, 'data', {})
          }
          loading.hide()
        },
        async getTransactionReport() {
          const loading = this.$loading.show()
          const params = {
            month: this.filterFormTransaction.month
          }

          const res = await ReportRepository.transactionPartnerReport(params)
          if (res.success) {
            this.dataTransaction = _.get(res, 'data', {})
          }
          loading.hide()
        },
    }
}
</script>

<style scoped>

</style>